import { render, staticRenderFns } from "./AdaptiveCommentForm.vue?vue&type=template&id=ac0621b4&"
import script from "./AdaptiveCommentForm.vue?vue&type=script&lang=js&"
export * from "./AdaptiveCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac0621b4')) {
      api.createRecord('ac0621b4', component.options)
    } else {
      api.reload('ac0621b4', component.options)
    }
    module.hot.accept("./AdaptiveCommentForm.vue?vue&type=template&id=ac0621b4&", function () {
      api.rerender('ac0621b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/AdaptiveCommentForm.vue"
export default component.exports